import { useEffect, useState } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import LazyLoad from "react-lazyload";
import Collapse from "react-bootstrap/Collapse";
import "./Filters.scss";

const studentStats = ["Trial", "Active", "Inactive"];
const classroomStatus = ["Live", "Completed", "Not Started"];

function Filters({
  dateProps = {},
  statusProps = {},
  subjectsProps = {},
  isLiveClasses = false,
}) {
  const status = statusProps?.isStudent ? studentStats : classroomStatus;
  const {
    startDate = "",
    endDate = "",
    setEndDate = () => {},
    setStartDate = () => {},
  } = dateProps;

  const { selectedStatus = [], setSelectedStatus = () => {} } = statusProps;

  const {
    selectedSubjects = [],
    setSelectedSubjects = () => {},
    subjectsOptions = [],
  } = subjectsProps;

  const [openStatus, setOpenStatus] = useState(false);
  const [openSubject, setOpenSubject] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [statusList, setStatusList] = useState(status);
  const [subjectsList, setSubjectsList] = useState([]);

  useEffect(() => {
    setSubjectsList(subjectsOptions);
  }, [subjectsOptions]);

  const handleSearch = (e) => {
    const searchKeyword = e.target.value;
    if (searchKeyword?.length > 0) {
      const filteredList = status.filter((sta) => sta.includes(searchKeyword));
      setStatusList(filteredList);
    } else {
      setStatusList(status);
    }
  };

  const handleSubjectsSearch = (e) => {
    const searchKeyword = e.target.value;
    if (searchKeyword?.length > 0) {
      const filteredList = subjectsOptions.filter((sta) =>
        sta?.name?.includes(searchKeyword)
      );
      setSubjectsList(filteredList);
    } else {
      setSubjectsList(subjectsOptions);
    }
  };

  const onStatusFilter = (updatedStatue) => {
    if (selectedStatus.includes(updatedStatue)) {
      setSelectedStatus(selectedStatus.filter((sta) => sta !== updatedStatue));
    } else {
      setSelectedStatus([...selectedStatus, updatedStatue]);
    }
  };

  const onSubjectFilter = (updatedSubject) => {
    if (selectedSubjects.includes(updatedSubject?.id)) {
      setSelectedSubjects(
        selectedSubjects.filter((sta) => sta !== updatedSubject?.id)
      );
    } else {
      setSelectedSubjects([...selectedSubjects, updatedSubject?.id]);
    }
  };

  return (
    <div style={{ maxHeight: "370px", overflowY: "auto" }}>
      <div
        aria-controls="collapse-content"
        aria-expanded={openStatus}
        className="d-flex justify-content-between"
        onClick={() => setOpenStatus(!openStatus)}
        style={{
          padding: "12px 10px 12px 10px",
        }}
      >
        <div
          style={{
            fontFamily: "Plus Jakarta Sans",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "19.36px",
            textAlign: "left",
            color: "#5A6A85",
          }}
        >
          Status
        </div>
        <LazyLoad height={20} offset={100}>
          <img
            src={openStatus ? "/ChevronUp.svg" : "/ChevronDown.svg"}
            alt="right-arrow"
          />
        </LazyLoad>
      </div>
      <Collapse in={openStatus}>
        <div
          style={{
            padding: "10px 11px 10px 11px",
            backgroundColor: "#F1F3FA",
          }}
        >
          <InputGroup>
            <Form.Control
              placeholder="Search status"
              aria-label="Search status"
              aria-describedby="basic-addon1"
              onChange={handleSearch}
              style={{
                color: "#8B97A8",
                background: "white",
                borderRightColor: "white",
              }}
            />
            <InputGroup.Text
              id="basic-addon1"
              style={{
                color: "#8B97A8",
                background: "white",
                borderLeftColor: "white",
              }}
            >
              <LazyLoad height={20} offset={100}>
                <img src="/Union.svg" alt="serach-icon" />
              </LazyLoad>
            </InputGroup.Text>
          </InputGroup>
          {statusList.map((statusLabel) => {
            return (
              <div
                style={{
                  padding: "12px 10px 12px 10px",
                }}
              >
                <Form.Check
                  checked={selectedStatus.includes(statusLabel)}
                  onChange={() => {
                    onStatusFilter(statusLabel);
                  }}
                  type="checkbox"
                  id="default-checkbox"
                  label={statusLabel}
                />
              </div>
            );
          })}
        </div>
      </Collapse>

      {isLiveClasses ? (
        <>
          <div
            aria-controls="collapse-content"
            aria-expanded={openSubject}
            className="d-flex justify-content-between"
            onClick={() => setOpenSubject(!openSubject)}
            style={{
              padding: "12px 10px 12px 10px",
            }}
          >
            <div
              style={{
                fontFamily: "Plus Jakarta Sans",
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: "19.36px",
                textAlign: "left",
                color: "#5A6A85",
              }}
            >
              Subjects
            </div>
            <LazyLoad height={20} offset={100}>
              <img
                src={openSubject ? "/ChevronUp.svg" : "/ChevronDown.svg"}
                alt="right-arrow"
              />
            </LazyLoad>
          </div>
          <Collapse in={openSubject}>
            <div
              style={{
                padding: "10px 11px 10px 11px",
                backgroundColor: "#F1F3FA",
              }}
            >
              <InputGroup>
                <Form.Control
                  placeholder="Search status"
                  aria-label="Search status"
                  aria-describedby="basic-addon1"
                  onChange={handleSubjectsSearch}
                  style={{
                    color: "#8B97A8",
                    background: "white",
                    borderRightColor: "white",
                  }}
                />
                <InputGroup.Text
                  id="basic-addon1"
                  style={{
                    color: "#8B97A8",
                    background: "white",
                    borderLeftColor: "white",
                  }}
                >
                  <LazyLoad height={20} offset={100}>
                    <img src="/Union.svg" alt="serach-icon" />
                  </LazyLoad>
                </InputGroup.Text>
              </InputGroup>
              {subjectsList.map((label) => {
                return (
                  <div
                    style={{
                      padding: "12px 10px 12px 10px",
                    }}
                  >
                    <Form.Check
                      checked={selectedStatus.includes(label?.id)}
                      onChange={() => {
                        onSubjectFilter(label);
                      }}
                      type="checkbox"
                      id="default-checkbox"
                      label={label?.name}
                    />
                  </div>
                );
              })}
            </div>
          </Collapse>
        </>
      ) : (
        ""
      )}

      {!isLiveClasses ? (
        <>
          <div
            aria-controls="collapse-content"
            aria-expanded={openDate}
            onClick={() => setOpenDate(!openDate)}
            className="d-flex justify-content-between"
            style={{
              padding: "12px 10px 12px 10px",
            }}
          >
            <span
              style={{
                fontFamily: "Plus Jakarta Sans",
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: "19.36px",
                textAlign: "left",
                color: "#5A6A85",
              }}
            >
              Date
            </span>
            <LazyLoad height={20} offset={100}>
              <img
                src={openDate ? "/ChevronUp.svg" : "/ChevronDown.svg"}
                alt="right-arrow"
              />
            </LazyLoad>
          </div>
          <Collapse in={openDate}>
            <div
              style={{
                padding: "10px 11px 10px 11px",
                backgroundColor: "#F1F3FA",
              }}
            >
              <label for="date" class="col-form-label">
                From start date
              </label>
              <input
                type="date"
                value={startDate}
                class="form-control"
                id="date"
                style={{
                  background: "white",
                }}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              />
              <label for="date" class="col-form-label">
                To end date
              </label>
              <input
                type="date"
                value={endDate}
                class="form-control"
                id="date"
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                style={{
                  background: "white",
                }}
              />
            </div>
          </Collapse>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default Filters;
